import CIcon from '@coreui/icons-react'
import { cilExternalLink, cilLockLocked } from '@coreui/icons'
import type { ServiceRecord } from '../../api/types'
import { formatDateTime } from '../../utils/format'

export function ServiceCard({ service, launch = false }: { service: ServiceRecord; launch?: boolean }) {
  return (
    <article className="service-card">
      <div className="service-card__top">
        <span className={`service-status service-status-${service.status}`}>
          <i />
          {service.status}
        </span>
        {service.owner && <small>{service.owner}</small>}
      </div>
      <h3>{service.name}</h3>
      <p>{service.publicDescription}</p>
      {service.statusMessage && <div className="service-card__message">{service.statusMessage}</div>}
      <div className="service-card__bottom">
        <span>
          {service.lastCheckedAt
            ? `Checked ${formatDateTime(service.lastCheckedAt)}`
            : 'Status maintained by LARICE'}
        </span>
        {launch && service.authorized && service.launchUrl ? (
          <a className="btn btn-primary" href={service.launchUrl} target="_blank" rel="noreferrer">
            Launch <CIcon icon={cilExternalLink} />
          </a>
        ) : launch ? (
          <span className="locked">
            <CIcon icon={cilLockLocked} /> Access not assigned
          </span>
        ) : (
          <span>FreeIPA access</span>
        )}
      </div>
    </article>
  )
}
